import { memo, useMemo } from 'react'
import { Typography } from '@mui/material'
import { CPPOResellerAgreementState } from '../../../modules/cppoResellerAgreement/reducer'
import { Box } from '@labrav/react-components'
import { useStyles } from './AboutAgreement.styles'
import clsx from 'clsx'
import { DateTime } from 'luxon'
import { startCase } from 'lodash'
import { useSelector } from '../../../store'
import { isEmpty } from 'lodash'
import { fullMonthYearWeekDay } from '@labrav/common'
import { CPPOAgreementPricingTypes } from '../../../modules/cppoResellerAgreement/actions'

export const AboutAgreement = memo(() => {
  const { classes } = useStyles()
  const aboutAgreementValues = useSelector<Partial<CPPOResellerAgreementState>>(
    ({ cppoResellerAgreement }) => ({
      agreementName: cppoResellerAgreement.agreementName,
      agreementExpirationDate: cppoResellerAgreement.agreementExpirationDate,
      discountType: cppoResellerAgreement.discountType,
      percentageDiscount: cppoResellerAgreement.percentageDiscount,
      agreementDescription: cppoResellerAgreement.agreementDescription,
      buyerAwsAccountId: cppoResellerAgreement.buyerAwsAccountId,
    })
  )
  const {
    agreementName,
    agreementExpirationDate,
    discountType,
    percentageDiscount,
    agreementDescription,
    buyerAwsAccountId,
  } = aboutAgreementValues

  const agreementExpDate = useMemo(() => {
    if (agreementExpirationDate) {
      const date = DateTime.fromISO(agreementExpirationDate)
      if (!date.isValid) {
        return 'N/A'
      }
      return date.toFormat(fullMonthYearWeekDay)
    }
    return 'N/A'
  }, [agreementExpirationDate])
  if (
    isEmpty(aboutAgreementValues) ||
    Object.values(aboutAgreementValues).every(value => !value)
  ) {
    return <div></div>
  }

  return (
    <div className={classes.root}>
      <Box heading={'About Agreement'} subHeading={''}>
        <div className={classes.agreementInfo}>
          <div className={classes.agreementRow}>
            <Typography className={clsx(classes.title, classes.bold)}>
              {agreementName}
            </Typography>
            <Typography className={classes.title}>
              Expires on {agreementExpDate}
            </Typography>
          </div>
          <div className={classes.agreementRow}>
            <Typography className={clsx(classes.title, classes.bold)}>
              {discountType ? startCase(discountType) : 'N/A'}
            </Typography>
            {discountType === CPPOAgreementPricingTypes.DISCOUNT &&
              percentageDiscount && (
                <Typography className={classes.title}>
                  {percentageDiscount}% discount
                </Typography>
              )}
          </div>
        </div>

        <div className={classes.agreementDescriptions}>
          <div className={classes.agreementTitleValue}>
            <Typography className={classes.agreementTitle}>
              Agreement Description
            </Typography>
            <Typography className={classes.title}>
              {agreementDescription || 'N/A'}
            </Typography>
          </div>
          <div className={classes.agreementTitleValue}>
            <Typography className={classes.agreementTitle}>
              Buyer AWS account ID
            </Typography>
            <Typography className={classes.title}>
              {buyerAwsAccountId || 'N/A'}
            </Typography>
          </div>
        </div>
      </Box>
    </div>
  )
})
